import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2511cd13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notificacoes" }
const _hoisted_2 = { class: "message-header" }
const _hoisted_3 = { class: "message-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificacoes, (notificacao) => {
      return (_openBlock(), _createElementBlock("article", {
        class: _normalizeClass(["message", _ctx.contexto[notificacao.type]]),
        key: notificacao.id
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(notificacao.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(notificacao.text), 1)
      ], 2))
    }), 128))
  ]))
}